import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import BaseService from 'services/BaseService'
import { popNotification } from 'utils/popNotification'
import { notificationConfig } from './constants'
import { LIMIT } from 'constants/app.constant'
import { formatDateSend } from '../../functions/formatDateSend'
import formatToDH from 'functions/dhformat'
const { creation, edit, deletion } = notificationConfig

// Redux Toolkit slice
const categoriesArticleWebsiteSlice = createSlice({
    name: 'categoriesArticleWebsite',
    initialState: {
        data: [],
        isLoading: false,
        error: null,
        created: null,
        isDeleted: null,
        currentPage: 1,
    },
    reducers: {

        resetDetailsCategoriesArticle: (state) => {
            if (state.detailsCategoriesArticle == null) {
                state.detailsCategoriesArticle = ''
            } else {
                state.detailsCategoriesArticle = null
            }
        },
        startLoading: state => {
            state.isLoading = true;
        },
        stopLoading: state => {
            state.isLoading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCategoriesArticle.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchCategoriesArticle.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;
                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchCategoriesArticle.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })

            .addCase(fetchDetailsCategoriesArticle.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchDetailsCategoriesArticle.fulfilled, (state, action) => {
                state.isLoading = false
                state.detailsCategoriesArticle = action.payload
            })
            .addCase(fetchDetailsCategoriesArticle.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })


            .addCase(createCategorie.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(createCategorie.fulfilled, (state, action) => {
                state.isLoading = false
                state.created = true
            })
            .addCase(createCategorie.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.created = false
            })

            .addCase(editCategorie.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(editCategorie.fulfilled, (state, action) => {
                state.isLoading = false
                state.created = true
            })
            .addCase(editCategorie.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.created = false
            })




    },
})

// Async thunk action to fetch data from the API
export const fetchCategoriesArticle = createAsyncThunk(
    'categoriesArticle/fetch',
    async (payload) => {
        const page = payload?.page || 1
        const limit = payload?.limit || LIMIT
        const search = payload?.search || ''
        const statut_f = payload?.statut_f || ''
        const stockable = payload?.stockable || ''
        let date_d_f = payload?.date?.[0] || ''
        let date_f_f = payload?.date?.[1] || ''
        if (dayjs(date_d_f).isValid() && dayjs(date_f_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
        } else if (dayjs(date_d_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = date_d_f;
        } else if (dayjs(date_f_f).isValid()) {
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
            date_d_f = date_f_f;
        }
        try {
            const response = await BaseService.get(
                `/XML/website.categoriesArticle.load?page=${page}&limit=${limit}&text=${search}&statut_f=${statut_f}&date_d_f=${date_d_f}&date_f_f=${date_f_f}&stockable=${stockable}`
            )

            return response.data
        } catch (error) {
            throw new Error('Failed to fetch categoriesArticle')
        }
    }
)




// Async thunk action to fetch data from the API
export const fetchDetailsCategoriesArticle = createAsyncThunk(
    'detailsCategoriesArticle/fetch',
    async ({ id }) => {
        try {
            const response = await BaseService.get(
                `/XML/website.categoriesArticle.load/details?id=${id}`
            )
            return response.data
        } catch (error) {
            throw new Error('Failed to fetch categoriesArticle')
        }
    }
)





export const createCategorie = createAsyncThunk(
    'categoriesArticle/post',
    async (payload) => {
        const { data, formik, navigate, setClientAdded } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/XML/website.categoriesArticle.send/add', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                setClientAdded(true)
            }
        } catch (err) {
            console.log({ err })
            setSubmitting(false)
            popNotification(creation?.error)
        }
    }
)


export const editCategorie = createAsyncThunk('categoriesArticle/edit',
    async (payload) => {
        const { data, formik, navigate, setClientAdded } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/XML/website.categoriesArticle.send/edit', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                setClientAdded(true)
            }
        } catch (err) {
            console.log({ err })
            setSubmitting(false)
            popNotification(creation?.error)
        }
    }
)



export const selectData = (state) => state.categoriesArticleWebsite.data
export const selectIsLoading = (state) => state.categoriesArticleWebsite.isLoading
export const selectError = (state) => state.categoriesArticleWebsite.error
export const selectIsDeleted = (state) => state.categoriesArticleWebsite.isDeleted
export const selectCurrentPage = (state) => state.categoriesArticleWebsite.currentPage
export const { resetDetailsCategoriesArticle, startLoading, stopLoading } = categoriesArticleWebsiteSlice.actions
export default categoriesArticleWebsiteSlice.reducer
